import {
    type DataFrame,
    type WsEvent,
} from 'src/services/websocket/ws-protocol';

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function isDataFrame(value: unknown): value is DataFrame {
    return isRecord(value) && typeof value.type === 'string';
}

function parseAuthError(frame: Record<string, unknown>): WsEvent {
    return typeof frame.reason === 'string' ?
        { type: 'AUTH_ERROR', reason: frame.reason } :
        { type: 'AUTH_ERROR' };
}

/**
 * Pure boundary parser for untrusted browser WebSocket message data. Auth
 * controls are normalized; every data frame is forwarded verbatim.
 */
export function parseIncomingWsFrame(raw: unknown): WsEvent | null {
    if (typeof raw !== 'string') {
        return null;
    }

    let frame: unknown;
    try {
        frame = JSON.parse(raw);
    } catch {
        return null;
    }
    if (!isDataFrame(frame)) {
        return null;
    }

    switch (frame.type) {
        case 'auth_ok':
            return { type: 'AUTH_OK' };
        case 'auth_error':
            return parseAuthError(frame);
        default:
            return { type: 'FRAME', frame };
    }
}
